module.exports = __webpack_public_path__ + "img/liangguangmofakoudaiWu.min.c6c0c72a.png";